import * as React from 'react';

const ProductSuggestion = ({ productUrl , isContactLens , isSolutions , onClick , brand , name , imageUrl ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-suggestion"
    }, /*#__PURE__*/ React.createElement("a", {
        className: "product-suggestion__link",
        href: productUrl,
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("span", {
        className: "product-suggestion__image-holder"
    }, /*#__PURE__*/ React.createElement("img", {
        className: "product-suggestion__image",
        src: imageUrl,
        alt: brand
    })), /*#__PURE__*/ React.createElement("span", {
        className: "product-suggestion__name-holder"
    }, !isContactLens && !isSolutions && /*#__PURE__*/ React.createElement("span", null, brand, " "), /*#__PURE__*/ React.createElement("span", {
        className: "product-suggestion__name"
    }, name))));
};

export { ProductSuggestion, ProductSuggestion as default };
//# sourceMappingURL=ProductSuggestion.js.map
